$(document).ready(function(){ 
  setTimeout(function() {
    var ratingss = $('.jdgm--js').attr('data-average-rating');
    if(ratingss == '0.00'){
      console.log('dfdfdf');
      $('.jdgm--js').parent().hide();
    }
  }, 2500);
  $(".SearchField").mouseenter(function(){
  $(".inout-search-wrapper").addClass("input-search-wrapper-active");
  })
  $(".SearchField").mouseleave(function(){
  $(".inout-search-wrapper").removeClass("input-search-wrapper-active");
  })
  $(".SearchField").focus(function(){
  $(".inout-search-wrapper").addClass("input-search-wrapper-focused");
  })
  $(".SearchField").focusout(function(){
   var Length =  $(this).val().length;
    if(Length==0){
    $(".inout-search-wrapper").removeClass("input-search-wrapper-focused");
    }
  //$(this).parents("form").addClass("focused-search");
  })
  $(".SearchField").keyup(function(){ 
  var GetSearchValue = $(this).val();
   GetSearchValue =  GetSearchValue.toLowerCase();
    var GetSearchCount = $(this).val().length;
     if(GetSearchCount>1)
     {       
       $(this).parents(".inout-search-wrapper").next(".searchListingNew").children(".SearchChild").each(function(){
       var GetProductName = $(this).attr("data-name");
         if(GetProductName.indexOf(GetSearchValue) != -1){
         $(this).addClass("matchstring");
           //console.log(GetSearchValue); 
         }
         else{
         $(this).removeClass("matchstring");
          //console.log("NO");
         }
       }) 
     }  
    else{
    //console.log("less");
       $(this).parents(".inout-search-wrapper").next(".searchListingNew").children(".SearchChild").removeClass("matchstring");
    }
     
    if(GetSearchCount>1)
     {      
       $(".SearchChild").each(function(){
       var GetProductName = $(this).attr("data-tags");
         if(GetProductName.indexOf(GetSearchValue) != -1){
         $(this).addClass("matchstringTag");
           //console.log(GetSearchValue); 
         } 
         else{ 
         $(this).removeClass("matchstringTag");
           //console.log("more");
         }
       })      
     }  
    else{
    //console.log("newless");
       $(this).parents(".inout-search-wrapper").next(".searchListingNew").children(".SearchChild").removeClass("matchstringTag");
    }
     var LengthTitle = $(".matchstring").length;
     var LengthTag = $(".matchstringTag").length;
    //console.log("GetSearchCount: "+GetSearchCount);
    if(GetSearchCount>1){
    if((LengthTitle == 0)&&(LengthTag == 0)){
    $("#noresults").show();
    }
    else{
    $("#noresults").hide();
    }
      //console.log("IFF");
    }
    else{
    $("#noresults").hide();
    }
  });
  $(".yoo-hm-shop-cat-row").click(function(e){
    e.preventDefault();
    //alert("CLICK");  
  var GetLink = $(this).children(".yoo-hm-shop-cat-cont").children(".yoo-hm-shop-cat-desc").children(".yoo-hm-shop-cat-btn").children("a").attr("href");
  window.location.href = GetLink;
  }) 
//   setTimeout(function(){ 
//   $(".item-slick-thumb.slick-slide.slick-active").each(function(){
//   var GetNumber = $(this).attr("data-slick-index");
//     if(GetNumber == 1)
//     {
//     $(this).trigger("click");
//     }   
//   })
//    }, 4000);       
//   $(".CustomSingleImageMobile .slick-dots li").each(function(){
//   var GetNumber = $(this).children("button").html();
//     if(GetNumber == 2)
//     {
//     $(this).trigger("click");
//     } 
//   })
//   $(".BlogSection-2").click(function(){
//     if (document.location.pathname.indexOf("/pages/celebrating-discovery-blogs") == 0) {
//     $('html, body').animate({
//         scrollTop: $("#BlogSection-2").offset().top-100
//     }, 2000);
// }
//     else{
//     window.location.href = "https://store.yookidoo.com/pages/celebrating-discovery-blogs#BlogSection-2";
//     }
  
//   })
//   $(".BlogSection-3").click(function(){
//     if (document.location.pathname.indexOf("/pages/celebrating-discovery-blogs") == 0) {
//     $('html, body').animate({
//         scrollTop: $("#BlogSection-3").offset().top-100
//     }, 2000);
// }
//     else{
//     window.location.href = "https://store.yookidoo.com/pages/celebrating-discovery-blogs#BlogSection-3";
//     }
  
//   })   
//   $(".BlogSection-4").click(function(){
//     if (document.location.pathname.indexOf("/pages/celebrating-discovery-blogs") == 0) {
//     $('html, body').animate({
//         scrollTop: $("#BlogSection-4").offset().top-100
//     }, 2000);
// }
//     else{
//     window.location.href = "https://store.yookidoo.com/pages/celebrating-discovery-blogs#BlogSection-4";
//     }
  
//   })
  if (screen.width > 749) {  
    $('.yoo-hm-best-sel-row-custom').removeClass("owl-carousel owl-theme");
     $('.yoo-hm-best-sel-row-custom').addClass("yoo-hm-best-sel-row");
  }     
   if (screen.width < 750) { 
 $('.yoo-hm-best-sel-row-custom').owlCarousel({
                center: true,
                items: 1,
                loop: true
              });   
      
   }     

     
 // for desktop bestseller 
$('.yoo-hm-best-sel-row').slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1
});
// end desktop best seller
  if (screen.width < 601) {
      $('.yoo-hm-shop-age-row').owlCarousel({
                center: true,
                items: 1,
                loop: true
              });
  } 
  if ( $(window).width() > 600 && $(window).width() < 661){
      $('.yoo-hm-shop-age-row').owlCarousel({
                center: true,
                items: 2,
                loop: true
              });
  }
  if ( $(window).width() > 660 && $(window).width() < 750){
      $('.yoo-hm-shop-age-row').owlCarousel({
                center: true,
                items: 3,
                loop: true
              });  
  }   
  /*********** Header ****************/
   $(window).scroll(function() {
  if($(window).scrollTop() > 48){
    $(".custom-header").addClass("custom-header-fixed");
    $(".cart-header").addClass("FixedCartHeader");
  }
  else{
   $(".custom-header").removeClass("custom-header-fixed");
     $(".cart-header").removeClass("FixedCartHeader");
  }
  })
  /****************Insta Slider ***************/
  if ($(window).width() > 1440) {
   $('.yoo-hm-insta-sec-cont-list').slick({
    dots: false,
      slidesToShow: 5,
    slidesToScroll: 1
  });
  }
  
  if ( $(window).width() > 749 && $(window).width() < 1441) {
   $('.yoo-hm-insta-sec-cont-list').slick({
    dots: false,
      slidesToShow: 5,
    slidesToScroll: 1
  });
  }
   
   if ( $(window).width() > 600 && $(window).width() < 750) {
   $('.yoo-hm-insta-sec-cont-list').slick({
    dots: false,
      slidesToShow: 3,
    slidesToScroll: 1
  });
  }
    
  if (screen.width < 601) {
    $('.yoo-hm-insta-sec-cont-list').slick({
    dots: false,
      slidesToShow: 1,
    slidesToScroll: 1
  });
  } 
  /*************** Subscription Popup *****************/
  
  setTimeout(function(){ 
    var popup_value = getCookie("subscription_popup");
    if(popup_value==1){}
    else{  
  $(".yoo-welcome-popup-main").addClass("yoo-welcome-popup-open");
      $("body").addClass("yoo-overflow-hide");
    }  
  }, 30000); 
$('body').on('click', '.privy-dismiss-content', function() {
  $(".yoo-welcome-popup-close").trigger("click");
  })
  $(".yoo-welcome-popup-close").click(function(){
  $(".yoo-welcome-popup-main").removeClass("yoo-welcome-popup-open");
    $("body").removeClass("yoo-overflow-hide");
    setCookie("subscription_popup", 1, 365);
	   
  }) 
function setCookie(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
      var expires = "expires="+d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(';');
      for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }
	
		 
  
  /*************Search Functionality**************/
  var getvalue = $(".product_names").html();
  getvalue = getvalue.split(',');
  //BindControlsNew();
//   function BindControlsNew() {
//     const arrBirds =getvalue;

//     $("#myInputmobile").autocomplete({
//       source: arrBirds,
//       minLength: 2,
//       scroll: true,
//       response: function(event, ui) {
//             // ui.content is the array that's about to be sent to the response callback.
//             if (ui.content.length === 0) {
//               console.log("testin");
//                 $("#noresultsmobile").show();
              
//             } else {
//               console.log("testin12");
//                 $("#noresultsmobile").hide();
//             }
//         }
//     }).data("ui-autocomplete")._renderItem = function( ul, item ) {
//       //let hreff = item.attr("href");
      
//       var getval = item.value ;
//       console.log(getval);
//       var getvalsplit = getval.split('href="');
//       var getvalsplit1 = getvalsplit[1].split('">');
//       var atthref = getvalsplit1[0];
//       //console.log("atthref="+atthref);
//      // console.log("item=="+getval);
//       let txt = String(item.value).replace(new RegExp(this.term, "gi"),"<b>$&</b>");
//       //console.log("txt=="+txt);
//       var getvalsplitt = txt.split('">');
//       var getvalsplitt1 = getvalsplitt[1].split('</a>');
//       var atthreff = getvalsplitt1[0];
//       var anchor  = '<a href="'+atthref+'">'+atthreff+'</a>';
//       //console.log("anchor=="+anchor);
//       return $("<li></li>")
//       .data("ui-autocomplete-item", item)
//       .append(anchor)
//       .appendTo(ul);
//     };
//   }
  
  $("input#myInput").keyup(function(){
    var inputval = $(this).val();
              if(inputval == ''){
                $("#noresults").hide();
              }
  })
  $("input#myInputmobile").keyup(function(){
    var inputval = $(this).val();
              if(inputval == ''){
                $("#noresultsmobile").hide();
              }
  })
//   BindControls();
//   function BindControls() {
//     const arrBirds =getvalue;

//     $("#myInput").autocomplete({
//       source: arrBirds,
//       minLength: 2,
//       scroll: true,
//       response: function(event, ui) {
//             // ui.content is the array that's about to be sent to the response callback.
//             if (ui.content.length === 0) {
//               console.log("testin");
//                 $("#noresults").show();
              
//             } else {
//               console.log("testin12");
//                 $("#noresults").hide();
//             }
//         }
//     }).data("ui-autocomplete")._renderItem = function( ul, item ) {
//       //let hreff = item.attr("href");
      
//       var getval = item.value ;
//       var getvalsplit = getval.split('href="');
//       var getvalsplit1 = getvalsplit[1].split('">');
//       var atthref = getvalsplit1[0];
//       //console.log("atthref="+atthref);
//      // console.log("item=="+getval);
//       let txt = String(item.value).replace(new RegExp(this.term, "gi"),"<b>$&</b>");
//       //console.log("txt=="+txt);
//       var getvalsplitt = txt.split('">');
//       var getvalsplitt1 = getvalsplitt[1].split('</a>');
//       var atthreff = getvalsplitt1[0];
//       var anchor  = '<a href="'+atthref+'">'+atthreff+'</a>';
//       console.log("anchor=="+anchor);
//       return $("<li></li>")
//       .data("ui-autocomplete-item", item)
//       .append(anchor)
//       .appendTo(ul);
      
//     };
//   }
  $('body').on('click', '.ui-menu-item', function(e) {
    //e.preventDefault();
    
    var GetHtml = $(this).children("a").html();
    GetHtml = GetHtml.replace("<b>","");
    GetHtml = GetHtml.replace("</b>","");
  //  alert(GetHtml);
    $("#myInput").val(GetHtml);
    $("#myInputmobile").val(GetHtml);
  $(".search-form.search-bar__form.focused-search").submit();
  })
  
  $("#myInput").focus(function(){
  $(this).parents("form").addClass("focused-search");
  })
  $("#myInput").focusout(function(){
   var Length =  $(this).val().length;
    if(Length==0){
    $(this).parents("form").removeClass("focused-search");
    }
  //$(this).parents("form").addClass("focused-search");
  })
  

  /******HomePage ****************/

$('.yoo-hm-banner-inn, .yoo-pg-banner-ct-row').slick({
     dots: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  speed: 1500,
    arrows: true,
    autoplay: true,
  //cssEase: 'ease-in-out',
    autoplaySpeed: 8100
  // dots: true,
  // slidesToShow: 1,
  // slidesToScroll: 1,
  // autoplay: true,
  //  fade: true,
  //   //speed: 8000,
  //   infinite: true,
  //   cssEase: 'ease-in-out',
  //   touchThreshold: 100,
  //   autoplaySpeed: 7999
});

  $(".custom-search-bar form").mouseenter(function(){
  $(this).addClass("search-expend");
  $(this).children(".search-form__input-wrapper").children(".search-form__input").addClass("search-text-open");
  })
  $(".custom-search-bar form").mouseleave(function(){
  $(this).removeClass("search-expend");
     $(this).children(".search-form__input-wrapper").children(".search-form__input").removeClass("search-text-open");
  })
  
/******************Awrad Wining *********************/  
if (screen.width > 1442) {
    

 $(function() { 
// Card's slider
  var $carousel = $('.slider-for');

  $carousel
    .slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
    centerMode: true,
//       adaptiveHeight: true,
      asNavFor: '.slider-nav'
    })
    
  $('.slider-nav').slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    centerMode: true,
  centerPadding: '60px'
  });
});
  }
  
    if ( $(window).width() > 749 && $(window).width() < 1442) {

 $(function() { 
// Card's slider
  var $carousel = $('.slider-for');

  $carousel
    .slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
    centerMode: true,
//       adaptiveHeight: true,
      asNavFor: '.slider-nav'
    })
    
  $('.slider-nav').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    centerMode: true,
  centerPadding: '60px'
  });
});
  }
  if ( $(window).width() > 749 && $(window).width() < 1025) {
 
 $(function() { 
// Card's slider
  var $carousel = $('.slider-for');

  $carousel
    .slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
    centerMode: true,
//       adaptiveHeight: true,
      asNavFor: '.slider-nav'
    })
    
  $('.slider-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    centerMode: true,
  centerPadding: '60px'
  });
});
  }
  if ( $(window).width() > 600 && $(window).width() < 750)
    
  {
 $(function() { 
// Card's slider
  var $carousel = $('.slider-for');
 
  $carousel
    .slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
    centerMode: true,
//       adaptiveHeight: true,
      asNavFor: '.slider-nav'
    })
    
  $('.slider-nav').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    centerMode: true,
  centerPadding: '60px'
  });
});
  }
   
  if (screen.width < 601) {
  $(function() { 
// Card's slider
  var $carousel = $('.slider-for');

  $carousel
    .slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
    centerMode: true,
//       adaptiveHeight: true,
      asNavFor: '.slider-nav'
    })
    
  $('.slider-nav').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    centerMode: true,
  centerPadding: '60px'
  });
});
  } 
  var offset1 = $("div#scrolltopwhite").offset().top;
   //alert(offset1);
  $(window).scroll(function() {
      
    //console.log($(this).scrollTop());
    var windowpos = $(window).scrollTop();
    if ($(this).scrollTop() > 100) { 
        $(".bottom_top").addClass("show_icon");
    }
    else{
    $(".bottom_top").removeClass("show_icon");
    }

});
  $('.bottom_top').on("click",function(){
      $("html").animate({ scrollTop: 0 }, "slow");
});
//   if (screen.width < 601) {
//   $('.yoo-hm-shop-age-row').slick({
//     dots: false,
//       slidesToShow: 1,
//     slidesToScroll: 1,
//     centerMode: true,
//   centerPadding: '60px'
//   });
//   }
//   if ( $(window).width() > 600 && $(window).width() < 750)
//   {
//     $('.yoo-hm-shop-age-row').slick({
//     dots: false,
//       slidesToShow: 3,
//     slidesToScroll: 1,
//     centerMode: true,
//   centerPadding: '60px'
//   });
//     }
  
//   console.log("testingajaxcomplete123");
//   function myFunction() {
//     var refreshId =setInterval(function(){ 
//       var gethtml = $("div#mce-success-response").html();
//       if(gethtml == 'Thank you for subscribing!'){
//         $(".yoo-welcome-popup-close").trigger("click");
//         clearInterval(refreshId);
//       }
//     }, 1000);
//   }
//   $('input#mc-embedded-subscribe').on("click",function(){
//     myFunction();
//   });
  
 
  
//   scroll to top color change starts here
  $(window).scroll(function() {
    var hT = $('#scrolltopwhite').offset().top,
        hH = $('#scrolltopwhite').outerHeight(),
        wH = $(window).height(), 
        wS = $(this).scrollTop();
    //var getdiv = $('.custom-tabs-scroll').offset().top;
   
    if (wS > (hT+hH-wH)){
      $(".bottom_top").addClass("bottom_top_white");
    }
    else{
      $(".bottom_top").removeClass("bottom_top_white");
    }
        
//     if ($(this).scrollTop() > getdiv) { 
      
//         $(".yoo-sin-pro-fixed-bottom").addClass("ShowFixdBar");
//     }
//     else{
     
//     $(".yoo-sin-pro-fixed-bottom").removeClass("ShowFixdBar");
//     }
  });
  //   scroll to top color change ends here
  
  /***************Mobile Menu ****************/
  $(".custom-mobile-icon").click(function(){
  $("body").toggleClass("mobile-menu-open");
  })
  $(".yoo-mob-menu-has-list>a").click(function(){
  $(this).parents(".yoo-mob-menu-has-list").toggleClass("yoo-mob-menu-has-list-open");
  })
  /************Mobile Search ************/
  $(".mobile-search-icon").click(function(){
    $("body").toggleClass("mobile-search-form-open");
  $(".mobile-search-form").toggleClass("show-search-mobile-form");
  })
  $('body').on('click', '.product-form--variant-sold-out button.btn.product-form__cart-submit', function(e) {
                  
    e.preventDefault();
    $(".custom-notify-sect").show();
    $(".yoo-sin-pro-info-tab-box-upr").hide();
    $(".yoo-sin-pro-info-tab-box-desc").hide();
  }); 
 
       
}); 



$(document).ready(function() {

$(".yoo-sin-pro-play-dev-sec .yoo-sin-pro-play-dev-box").each(function(){
    if ($(this).children(".yoo-sin-pro-play-dev-box-tab-upr").find("h3").text() == 'Cognitive Development') {
        $(this).children(".yoo-sin-pro-play-dev-box-tab-upr").find(".yoo-sin-pro-play-dev-box-desk-img").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-Cognitive_Development.svg?v=1649321360");
        $(this).children(".yoo-sin-pro-play-dev-box-tab-upr").find(".yoo-sin-pro-play-dev-box-mob-img").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-Cognitive-Development_f53d12f2-8525-4756-863c-ee61b4c50f92.svg?v=1649321520");
    }

    if ($(this).children(".yoo-sin-pro-play-dev-box-tab-upr").find("h3").text() == 'Physical Development') {
        $(this).children(".yoo-sin-pro-play-dev-box-tab-upr").find(".yoo-sin-pro-play-dev-box-desk-img").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-Physical-Development_e11c9037-b2b4-41b0-b6c5-f6b7fdfa57c6.svg?v=1649321360");
        $(this).children(".yoo-sin-pro-play-dev-box-tab-upr").find(".yoo-sin-pro-play-dev-box-mob-img").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-Physical-Development_0767b330-677d-474f-93b3-8caae1215b77.svg?v=1649321520");
    }

    if ($(this).children(".yoo-sin-pro-play-dev-box-tab-upr").find("h3").text() == 'Social & Emotional Development') {
        $(this).children(".yoo-sin-pro-play-dev-box-tab-upr").find(".yoo-sin-pro-play-dev-box-desk-img").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-Social___Emotional-Development_8a77a2de-6ca2-470f-ab86-b25123a0f5b7.svg?v=1649321360");
        $(this).children(".yoo-sin-pro-play-dev-box-tab-upr").find(".yoo-sin-pro-play-dev-box-mob-img").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-Social-Emotional-Development.svg?v=1649321520");
    }
  });  
  $(".yoo-sin-pro-play-dev-inn .yoo-sin-pro-play-dev-sec .yoo-sin-pro-play-dev-box .yoo-sin-pro-play-dev-box-tab .yoo-sin-pro-play-dev-box-tab-blk").each(function(){
     if ($(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find("h4").text() == 'Learning skills') {
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-desk").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-Learning-Skills_c584b7c4-2450-4242-92d2-4559a779a9f1.svg?v=1649321360");
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-mob").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-Learning-Skills_50176225-7b3f-492c-84ec-28c0b253becb.svg?v=1649321520");
     }

     if ($(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find("h4").text() == 'Knowledge Acquisition') {
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-desk").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-knowledge_aquestion.svg?v=1649321360");
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-mob").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-knowledge-aquestion_1be2a9de-7fd6-4604-aad3-ace42ea5b4af.svg?v=1649321520");
     }

     if ($(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find("h4").text() == 'Curiosity') {
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-desk").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-curiosity_5043e460-485e-42e1-a50e-eecd826fdd39.svg?v=1649321360");
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-mob").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-curiosity_c0b5df2f-d029-4135-a5b3-b3c7483a9086.svg?v=1649321520");
     }

     if ($(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find("h4").text() == 'Fine Motor Skills') {
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-desk").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-Fine-Motor-Skills_ddbd7ff4-d3cf-426a-af27-348c84d728e0.svg?v=1649321360");
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-mob").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-Fine_Motor_Skills.svg?v=1649321520");
     }

     if ($(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find("h4").text() == 'Coordination') {
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-desk").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-coordination_0883120c-a20f-454c-8bec-526541b4466f.svg?v=1649321360");
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-mob").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-coordination_be45c34c-32d1-4fe5-8ab5-0e621821575c.svg?v=1649321520");
     }

     if ($(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find("h4").text() == 'Senses') {
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-desk").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-senses_967ec058-5a97-4f1a-b2cd-9cb1dfe2be15.svg?v=1649321360");
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-mob").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-senses_dbb563a1-dde7-49d4-a4d2-9071c67c388b.svg?v=1649321520");
     }

     if ($(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find("h4").text() == 'Self-Expression') {
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-desk").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-self-expression_9fc0099c-27a7-4888-bec2-9a0aba4651cd.svg?v=1649321360");
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-mob").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-self-expression_c91e6e3c-8cea-4a17-9e74-d2ad44f17a90.svg?v=1649321520");
     }

     if ($(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find("h4").text() == 'Confidence') {
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-desk").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-confidence_102967a4-6424-4eb8-9502-98ff26e49f1a.svg?v=1649321360");
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-mob").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-confidence_d676c1c5-52f0-4262-aa56-f10c12af2df1.svg?v=1649321520");
     }

     if ($(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find("h4").text() == 'Communication') {
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-desk").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-Communication_373d8507-2e1e-48d2-884c-406b29eb2b5c.svg?v=1649321360");
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-mob").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-Communication_dd1d4cb9-63b5-4400-888f-e8e2d85483bf.svg?v=1649321520");
     }

     if ($(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find("h4").text() == 'Imagination' || $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find("h4").text() == 'Imagination & Creativity') {
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-desk").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-Imagenation___Creativity.svg?v=1649321360");
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-mob").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-Imagenation___Creativity_a273429f-3801-402c-9894-85c41e409975.svg?v=1649321520");
     }

     if ($(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find("h4").text() == 'Cooperation' || $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find("h4").text() == 'Cooperation / Sharing' || $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find("h4").text() == 'Cooperation & Sharing' || $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find("h4").text() == 'Cooperation and Sharing') {
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-desk").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-cooperation___sharing_305c7ec9-6740-428d-86ea-70efc431def2.svg?v=1649321360");
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-mob").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-cooperation___sharing_84823468-0e58-46f7-806f-4129b2356a24.svg?v=1649321520");
     }

     if ($(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find("h4").text() == 'Gross Motor Skills') {
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-desk").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-Gross-Motor_Skills.svg?v=1649321360");
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-mob").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-Gross-Motor-Skills_46b7e739-062d-46a6-951f-e374dadf261c.svg?v=1649321520");
     }
  });
});

$(window).on('load', function() {
  setTimeout(function(){
  $(".yoo-sin-pro-play-dev-sec .yoo-sin-pro-play-dev-box").each(function(){
    $(this).find(".yoo-sin-pro-play-dev-desc-img").children("img").removeClass("lazyload");
    if ($(this).children(".yoo-sin-pro-play-dev-box-tab-upr").find("h3").text() == 'Cognitive Development') {
        $(this).children(".yoo-sin-pro-play-dev-box-tab-upr").find(".yoo-sin-pro-play-dev-box-desk-img").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-Cognitive_Development.svg?v=1649321360");
        $(this).children(".yoo-sin-pro-play-dev-box-tab-upr").find(".yoo-sin-pro-play-dev-box-mob-img").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-Cognitive-Development_f53d12f2-8525-4756-863c-ee61b4c50f92.svg?v=1649321520");
    }

    if ($(this).children(".yoo-sin-pro-play-dev-box-tab-upr").find("h3").text() == 'Physical Development') {
        $(this).children(".yoo-sin-pro-play-dev-box-tab-upr").find(".yoo-sin-pro-play-dev-box-desk-img").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-Physical-Development_e11c9037-b2b4-41b0-b6c5-f6b7fdfa57c6.svg?v=1649321360");
        $(this).children(".yoo-sin-pro-play-dev-box-tab-upr").find(".yoo-sin-pro-play-dev-box-mob-img").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-Physical-Development_0767b330-677d-474f-93b3-8caae1215b77.svg?v=1649321520");
    }

    if ($(this).children(".yoo-sin-pro-play-dev-box-tab-upr").find("h3").text() == 'Social & Emotional Development') {
        $(this).children(".yoo-sin-pro-play-dev-box-tab-upr").find(".yoo-sin-pro-play-dev-box-desk-img").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-Social___Emotional-Development_8a77a2de-6ca2-470f-ab86-b25123a0f5b7.svg?v=1649321360");
        $(this).children(".yoo-sin-pro-play-dev-box-tab-upr").find(".yoo-sin-pro-play-dev-box-mob-img").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-Social-Emotional-Development.svg?v=1649321520");
    }
  });  
  $(".yoo-sin-pro-play-dev-inn .yoo-sin-pro-play-dev-sec .yoo-sin-pro-play-dev-box .yoo-sin-pro-play-dev-box-tab .yoo-sin-pro-play-dev-box-tab-blk").each(function(){
     if ($(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find("h4").text() == 'Learning skills') {
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-desk").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-Learning-Skills_c584b7c4-2450-4242-92d2-4559a779a9f1.svg?v=1649321360");
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-mob").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-Learning-Skills_50176225-7b3f-492c-84ec-28c0b253becb.svg?v=1649321520");
     }

     if ($(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find("h4").text() == 'Knowledge Acquisition') {
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-desk").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-knowledge_aquestion.svg?v=1649321360");
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-mob").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-knowledge-aquestion_1be2a9de-7fd6-4604-aad3-ace42ea5b4af.svg?v=1649321520");
     }

     if ($(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find("h4").text() == 'Curiosity') {
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-desk").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-curiosity_5043e460-485e-42e1-a50e-eecd826fdd39.svg?v=1649321360");
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-mob").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-curiosity_c0b5df2f-d029-4135-a5b3-b3c7483a9086.svg?v=1649321520");
     }

     if ($(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find("h4").text() == 'Fine Motor Skills') {
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-desk").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-Fine-Motor-Skills_ddbd7ff4-d3cf-426a-af27-348c84d728e0.svg?v=1649321360");
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-mob").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-Fine_Motor_Skills.svg?v=1649321520");
     }

     if ($(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find("h4").text() == 'Coordination') {
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-desk").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-coordination_0883120c-a20f-454c-8bec-526541b4466f.svg?v=1649321360");
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-mob").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-coordination_be45c34c-32d1-4fe5-8ab5-0e621821575c.svg?v=1649321520");
     }

     if ($(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find("h4").text() == 'Senses') {
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-desk").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-senses_967ec058-5a97-4f1a-b2cd-9cb1dfe2be15.svg?v=1649321360");
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-mob").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-senses_dbb563a1-dde7-49d4-a4d2-9071c67c388b.svg?v=1649321520");
     }

     if ($(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find("h4").text() == 'Self-Expression') {
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-desk").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-self-expression_9fc0099c-27a7-4888-bec2-9a0aba4651cd.svg?v=1649321360");
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-mob").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-self-expression_c91e6e3c-8cea-4a17-9e74-d2ad44f17a90.svg?v=1649321520");
     }

     if ($(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find("h4").text() == 'Confidence') {
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-desk").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-confidence_102967a4-6424-4eb8-9502-98ff26e49f1a.svg?v=1649321360");
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-mob").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-confidence_d676c1c5-52f0-4262-aa56-f10c12af2df1.svg?v=1649321520");
     }

     if ($(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find("h4").text() == 'Communication') {
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-desk").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-Communication_373d8507-2e1e-48d2-884c-406b29eb2b5c.svg?v=1649321360");
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-mob").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-Communication_dd1d4cb9-63b5-4400-888f-e8e2d85483bf.svg?v=1649321520");
     }

     if ($(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find("h4").text() == 'Imagination' || $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find("h4").text() == 'Imagination & Creativity') {
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-desk").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-Imagenation___Creativity.svg?v=1649321360");
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-mob").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-Imagenation___Creativity_a273429f-3801-402c-9894-85c41e409975.svg?v=1649321520");
     }

     if ($(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find("h4").text() == 'Cooperation' || $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find("h4").text() == 'Cooperation / Sharing' || $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find("h4").text() == 'Cooperation & Sharing' || $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find("h4").text() == 'Cooperation and Sharing') {
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-desk").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-cooperation___sharing_305c7ec9-6740-428d-86ea-70efc431def2.svg?v=1649321360");
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-mob").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-cooperation___sharing_84823468-0e58-46f7-806f-4129b2356a24.svg?v=1649321520");
     }

     if ($(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find("h4").text() == 'Gross Motor Skills') {
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-desk").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-Gross-Motor_Skills.svg?v=1649321360");
        $(this).children(".yoo-sin-pro-play-dev-box-tab-desc").find(".yoo-sin-pro-play-img-icon-mob").attr("src", "https://cdn.shopify.com/s/files/1/0080/4313/5057/files/Icon-Gross-Motor-Skills_46b7e739-062d-46a6-951f-e374dadf261c.svg?v=1649321520");
     }
  });
 }, 500);
});


document.querySelectorAll(".arrow-rotate").forEach(item => {
  item.addEventListener("click", function () {
    if (this.classList.contains("active")) {
      this.classList.remove("active");
      return;
    }
    document.querySelectorAll(".arrow-rotate").forEach(el => el.classList.remove("active"));
    this.classList.add("active");
  });
});



